<!-- header -->
<app-header extraClass="text-gray nav-down" standardProduct=true displayNavigation=true></app-header>

<section class="booking-wrp">

    <div class="banner position-relative">
        <picture width="w-100">
            <source media="(max-width:767px)" srcset="assets/images/mobile-booking-banner.png">
            <img src="assets/images/booking-banner.jpg" alt="" class="w-100">
        </picture>
        <h4>Corporate Bookings</h4>
    </div>

    <div class="container">
        <div class="contact-info-wrp">

            <div class="contact-card-field-wrp mt-5 mb-1">
                <div class="border-form-input">
                    <form class="uk-flex uk-flex-wrap corporate-forn-inner">
                        <div class="form-group mb-2">
                            <div class="uk-inline">
                                <input class="uk-input" placeholder="Your Name" type="text" name="full_name" required="required">
                            </div>
                        </div>
                        <!--form-group End-->
                        <div class="form-group mb-2">
                            <div class="uk-inline">
                                <input class="uk-input" placeholder="Your Work Email ID" type="text" name="full_name" required="required">
                            </div>
                        </div>
                        <!--form-group End-->
                        <div class="form-group mb-2">
                            <div class="uk-inline">
                                <input class="uk-input" placeholder="Your Mobile Number" type="text" name="full_name" required="required">
                            </div>
                        </div>
                        <!--form-group End-->
                        <div class="form-group mb-2 arrow">
                            <div class="uk-form-controls">
                                <select class="uk-select uk-input">
                  <option selected>Select your City</option>
                  <option>Mumbai</option>
              </select>
                            </div>
                        </div>
                        <!--form-group End-->
                        <div class="form-group mb-2">
                            <div class="uk-inline">
                                <input class="uk-input" placeholder="Tell us your Company name" type="text" name="full_name" required="required">
                            </div>
                        </div>
                        <!--form-group End-->
                        <div class="form-group mb-2 arrow">
                            <div class="uk-form-controls">
                                <select class="uk-select uk-input">
                  <option selected>Select the occasion</option>
                  <option>Mumbai</option>
              </select>
                            </div>
                        </div>
                        <!--form-group End-->
                        <div class="form-group mb-2">
                            <div class="uk-inline">
                                <input class="uk-input" placeholder="Tell us preferred your dates" type="date" name="full_name" required="required">
                            </div>
                        </div>
                        <!--form-group End-->
                        <div class="form-group mb-2 arrow">
                            <div class="uk-form-controls">
                                <select class="uk-select uk-input">
                  <option selected>Select the number of people</option>
                  <option>Mumbai</option>
              </select>
                            </div>
                        </div>
                        <!--form-group End-->
                        <div class="form-group mt-2 w-100">
                            <textarea class="uk-textarea" required placeholder="Tell us more or if you have a preferred experience in mind!"></textarea>
                        </div>
                        <div class="form-group mt-3 w-100 btn-box uk-flex uk-flex-center">
                            <button type="submit" class="btn-yellow cursor-pointer">
              Submit
            </button>
                        </div>
                    </form>
                </div>
            </div>

            <p class="booking-msg mb-4">Thank you! Your enquriry has been submitted, our team will get back to you in 48 working hours.</p>

            <div class="contact-card-top uk-flex uk-flex-center mb-4">
                <div class="contact-card uk-flex">
                    <div class="icons">
                        <!-- <img src="assets/images/icons/call-2.png" alt="">-->
                        <i class="fa fa-phone fa-3x text-white"></i>

                    </div>
                    <div class="info">
                        <h3>Tollfree number</h3>
                        <a href="tel:18002567666">1800 266 7666</a>
                    </div>
                </div>
                <!--contact-card-->
                <div class="contact-card uk-flex">
                    <div class="icons">
                        <!--<img src="assets/images/icons/mail-2.png" alt="">-->
                        <i class="fa fa-envelope fa-3x text-white"></i>
                    </div>
                    <div class="info">
                        <h3>Email Id</h3>
                        <a href="mailto:support@things2.do">support@things2.do</a>
                    </div>
                </div>
                <!--contact-card-->
                <div class="contact-card uk-flex">
                    <div class="icons">
                        <!--<img src="assets/images/icons/call-3.png" alt="">-->
                        <i class="fa fa-clock-o fa-3x text-white"></i>
                    </div>
                    <div class="info">
                        <h3>Customer Care</h3>
                        <p>10 am - 8 pm</p>
                    </div>
                </div>
                <!--contact-card-->
            </div>
            <!--contact-card-top-->

        </div>
        <!--contact-info-wrp End-->
    </div>


</section>


<!-- footer -->
<app-footer></app-footer>
